import type { SVGProps } from "react";
export interface Settings01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Settings01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Settings01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.595 3.789c0-.354-.3-.664-.677-.664H11.08a.676.676 0 0 0-.675.664c0 1.218-.777 2.188-1.666 2.695-.899.512-2.116.667-3.164.072-.346-.197-.776-.067-.95.231L3.707 8.35a.65.65 0 0 0 .26.883l.19.118c.922.621 1.345 1.678 1.345 2.65 0 1.035-.482 2.168-1.535 2.767a.646.646 0 0 0-.26.881l.917 1.563c.175.299.605.428.951.232 1.048-.595 2.265-.439 3.164.073.89.507 1.666 1.477 1.666 2.695 0 .353.298.662.675.663h1.837a.676.676 0 0 0 .677-.663c0-1.218.775-2.188 1.664-2.695.899-.512 2.117-.668 3.165-.073.346.196.774.066.95-.232l.918-1.563a.647.647 0 0 0-.26-.881c-1.053-.599-1.534-1.732-1.535-2.768s.482-2.168 1.536-2.767a.647.647 0 0 0 .259-.881l-.919-1.565a.704.704 0 0 0-.815-.29l-.134.059c-1.048.595-2.266.44-3.165-.072-.89-.507-1.664-1.477-1.664-2.695Zm2.25 0c0 .216.155.527.528.74.365.207.725.194.94.071 1.378-.782 3.182-.348 4.001 1.049l.917 1.563.14.268c.618 1.36.073 2.97-1.228 3.709-.21.12-.396.411-.396.812 0 .4.186.69.396.81 1.301.739 1.847 2.35 1.229 3.709l-.14.268-.918 1.564c-.82 1.396-2.623 1.83-4 1.049-.216-.123-.576-.137-.94.07-.374.213-.53.525-.53.741a2.926 2.926 0 0 1-2.926 2.913H11.08a2.925 2.925 0 0 1-2.925-2.913c0-.216-.156-.528-.53-.74-.363-.209-.723-.194-.94-.071-1.29.733-2.957.397-3.836-.799l-.164-.25-.918-1.564c-.826-1.409-.3-3.19 1.088-3.978l.078-.052c.176-.141.319-.407.319-.757s-.143-.618-.32-.76l-.077-.052C1.468 10.4.94 8.62 1.768 7.212l.918-1.563.164-.25c.88-1.198 2.545-1.533 3.836-.799l.088.04c.219.082.534.07.853-.112.373-.212.528-.523.529-.74A2.926 2.926 0 0 1 11.08.876h1.837a2.927 2.927 0 0 1 2.927 2.914Z"
      />
      <path
        fill={color}
        d="M13.875 12a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m2.25 0a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
    </svg>
  );
}
